import { render, staticRenderFns } from "./MatchLookUp.vue?vue&type=template&id=3b958b05&scoped=true"
import script from "./MatchLookUp.vue?vue&type=script&lang=js"
export * from "./MatchLookUp.vue?vue&type=script&lang=js"
import style0 from "./MatchLookUp.vue?vue&type=style&index=0&id=3b958b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b958b05",
  null
  
)

export default component.exports